// src/store/store.ts
import { configureStore } from '@reduxjs/toolkit'
import createSagaMiddleware from 'redux-saga'
import feedReducer from './slice/feedSlice'
import authReducer from './slice/authSlice'
import boardReducer from './slice/boardSlice'
import commentReducer from './slice/commentSlice'
import mypageReducer from './slice/mypageListsSlice'
import alertsReducer  from './slice/alertsSlice';
import myPageReducer from './slice/myPageSlice';
import adminUsersReducer from './slice/adminUsersSlice';
import mainReducer  from './slice/mainSlice';
import rootSaga from './rootSaga'

const sagaMiddleware = createSagaMiddleware()

export const store = configureStore({
    reducer: {
        auth:     authReducer,
        feeds:    feedReducer,
        board:   boardReducer,
        comment:   commentReducer,
        alerts:      alertsReducer,
        mypageLists : mypageReducer,
        adminUsers: adminUsersReducer,
        myPage: myPageReducer,
        main : mainReducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({ thunk: true }).concat(sagaMiddleware),
})

sagaMiddleware.run(rootSaga)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
